module.exports = __webpack_public_path__ + "fa-brands-400.3b89dd103490708d19a9.ttf";


//////////////////
// WEBPACK FOOTER
// E:/xampp/htdocs/liberado/CocoraSMFront/src/assets/plugins/fontawesome-free/webfonts/fa-brands-400.ttf
// module id = ../../../../../src/assets/plugins/fontawesome-free/webfonts/fa-brands-400.ttf
// module chunks = styles